import { OrganisationsSeoIndexabilityPolicy } from '../../../organisations/policies/OrganisationsSeoIndexabilityPolicy';
import { AtLeastTwoRankedResultsRule } from '../../../organisations/rules/AtLeastTwoRankedResultsRule';
import { FilterCombinations } from '../../../enums/FilterCombinations';
import { SortingOptions } from '../../../enums/SortingOptions';
import { NoFiltersSelectedRule } from '../../../common/rules/NoFiltersSelectedRule';
export class RankedUnfiltered extends OrganisationsSeoIndexabilityPolicy {
    sortingOption = SortingOptions.UNIVERSITY_META_RANKING;
    rules = [new NoFiltersSelectedRule(), new AtLeastTwoRankedResultsRule()];
    async generateUrls() {
        return [];
    }
    get filterCombination() {
        return FilterCombinations.UNFILTERED;
    }
}
